import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Timeline,
} from 'antd';
import RichContent from '../../../coms/rich/RichContent';

const store = ['modeListStore'];
@inject(...store)
@observer
class App extends React.Component {

  regVersion = (version) => {
    const arr = /(\d\.\d{1,2})\.\d*(.*)/.exec(version);
    return arr && arr.length && arr.length >= 2 ? arr.slice(2).join() : version;
  }
  render() {
    const { prefixCls, modeListStore: { appDetail }  } = this.props;
    const ver = toJS(appDetail) ? toJS(appDetail).ver : null;
    const datas = ver ? ver.filter(v => v.status > 2) : [];
    return (
      <div className={prefixCls}>
        <Timeline>
          {
            datas.map(data => (
              <Timeline.Item key={data.id}>
                <h3>{this.regVersion(data.version)}</h3>
                <p><span className="time">{data.times}</span></p>
								<RichContent value={data.versiondesc} />
              </Timeline.Item>
            ))
          }
				</Timeline>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/mode/appDetail/Log.js